import { Radio, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [checked, setChecked] = useState(false);
	const onClick = () => setChecked(!checked);

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="enabled" />
			<Text semiBold text="disabled" />
			<Text semiBold text="disabled + checked" />
			<Radio checked={checked} onClick={onClick} />
			<Radio checked={false} disabled />
			<Radio checked disabled />
		</CssColumnGrid>
	);
};